import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/reports/case-list', { params }),
  getById: (id, params) => axios.get(`/api/v1/reports/case-list/${id}`,  { params }),
  create: (data) => axios.post('/api/v1/reports/case-list', data),
  update: (id, data) => axios.put(`/api/v1/reports/case-list/${id}`, data),
  delete: (ids) => axios.delete(`/api/v1/reports/case-list?${ids.map((id) => `ids[]=${id}`).join('&')}`),
};
